import { useState } from "react";
import { ArrowUpRight } from "lucide-react";

const SITE = "http://zeefatech.com/";
const NAME = "ZEEFA TECHNOLOGIES";
const LOGO = "/zeefa-logo.png";
const MARK = "/zeefa-mark.png";

const Img = ({ src, className, testid, fallback = null }) => {
  const [ok, setOk] = useState(true);
  return ok ? <img src={src} alt={NAME} className={`${className} w-auto object-contain`} onError={() => setOk(false)} data-testid={testid} /> : fallback;
};

export const BrandStrip = () => (
  <a href={SITE} target="_blank" rel="noopener noreferrer" data-testid="map-brand-strip"
    className="absolute bottom-7 sm:bottom-1.5 left-4 z-[1000] inline-flex items-center gap-2 px-2.5 h-7 bg-atlas-void/95 backdrop-blur border border-white/25 shadow-[0_2px_12px_rgba(0,0,0,0.6)] text-[10px] font-mono uppercase tracking-[0.1em] sm:tracking-[0.2em] whitespace-nowrap text-white hover:border-atlas-cyan/60 transition-colors">
    <span className="text-atlas-secondary">by</span>
    <Img src={MARK} className="h-5" testid="map-brand-mark" />
    <span className="font-semibold">ZEEFA<span className="hidden sm:inline"> TECHNOLOGIES</span></span>
  </a>
);

export const SiteFooter = () => (
  <footer className="mt-20 pt-6 border-t border-white/10" data-testid="site-footer">
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-5">
      <a href={SITE} target="_blank" rel="noopener noreferrer" data-testid="footer-brand-link" className="group inline-flex items-center gap-3">
        <span className="flex flex-col gap-2">
          <span className="text-[9px] font-mono uppercase tracking-[0.3em] text-atlas-secondary/85 inline-flex items-center gap-1">
            Built by
            <ArrowUpRight className="w-3 h-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform]" />
          </span>
          <Img src={LOGO} className="h-9 sm:h-10 opacity-90 group-hover:opacity-100 transition-opacity" testid="footer-brand-logo"
            fallback={<span className="text-sm font-display tracking-[0.18em] text-white">{NAME}</span>} />
        </span>
      </a>
      <div className="text-[10px] font-mono uppercase tracking-widest text-atlas-secondary/85 sm:text-right" data-testid="footer-copyright">
        <div>Vigilo Earth · planetary early warning</div>
        <div>© {new Date().getFullYear()} {NAME} · <a href={SITE} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-site-link">zeefatech.com</a></div>
      </div>
    </div>
  </footer>
);
